import { Link } from 'react-router-dom';
import fondoSatelite from '../FondoSecciónSatelite.png';
import '../styles/CTA.css';

function CTA() {
  return (
    <section id="cta" className="tm-section tm-cta-section">
      <div
        className="tm-cta-section-fondo"
        style={{ backgroundImage: `url(${fondoSatelite})` }}
        aria-hidden="true"
      />
      <div className="tm-cta-section-scrim" aria-hidden="true" />

      <div className="tm-container tm-cta-inner">
        <div className="tm-cta-unified">
          <header className="tm-cta-block tm-cta-block--satelite">
            <p className="tm-cta-brand-line">
              <span className="tm-cta-brand-white">modali</span>
              <span className="tm-cta-brand-gold">dad</span>
            </p>

            <h2 className="tm-cta-headline">HACIA TU NUEVA VIDA</h2>

            <p className="tm-cta-subhead">
              <span className="tm-cta-subhead-strong">Modalidad </span>
              <span className="tm-cta-subhead-accent">Satélite</span>
            </p>

            <p className="tm-cta-lead">
              Nuestro <strong>Nuevo Servicio</strong> de Cobertura Integral te conecta. Flexibilidad total
              para tu futuro.
            </p>

            <ul className="tm-cta-features">
              <li>
                <span className="material-symbols-outlined tm-cta-feature-icon" aria-hidden>
                  location_on
                </span>
                <span>
                  Cobertura en <strong>todo el MUNDO</strong>
                </span>
              </li>
              <li>
                <span className="material-symbols-outlined tm-cta-feature-icon" aria-hidden>
                  schedule
                </span>
                <span>Tu tiempo, tus reglas</span>
              </li>
              <li>
                <span className="material-symbols-outlined tm-cta-feature-icon" aria-hidden>
                  edit_note
                </span>
                <span>Registro y Entrevista Ágiles</span>
              </li>
            </ul>

            <div className="tm-cta-actions">
              <Link to="/modalidad-satelite" className="btn-hover tm-cta-btn-satelite">
                Modalidad Satélite
                <span className="material-symbols-outlined tm-cta-btn-satelite-icon">travel_explore</span>
              </Link>
              <Link to="/registro" className="btn-hover tm-cta-btn-agendar">
                Agendar entrevista
                <span className="material-symbols-outlined tm-cta-btn-agendar-icon">schedule</span>
              </Link>
            </div>
          </header>
        </div>
      </div>
    </section>
  );
}

export default CTA;
